<template>
    <div class="info_box">
        <div class="m-b-30" v-for="(item, index) in showObject" :key="index">
            <el-descriptions title="" direction="vertical" :column="3" border v-if="index === 0">
                <el-descriptions-item label="订单编号">
                    {{ item.orderNumber }}
                </el-descriptions-item>
                <el-descriptions-item label="订单状态">
                    {{ orderStatusList[item.status] }}
                </el-descriptions-item>
                <el-descriptions-item label="退款状态" v-if="item.refundStatus">
                    {{ refundStatusList[item.refundStatus] }}
                </el-descriptions-item>
                <el-descriptions-item label="支付方式">
                    {{ payList[item.payType] || '其他' }}
                </el-descriptions-item>
                <el-descriptions-item label="订单时间">
                    {{ item.createTime }}
                </el-descriptions-item>
                <el-descriptions-item label="发货时间">
                    {{ item.dvyTime }}
                </el-descriptions-item>
                <el-descriptions-item label="完成时间">
                    {{ item.finallyTime }}
                </el-descriptions-item>
                <el-descriptions-item label="订单备注" :span="3">
                    {{ item.remarks }}
                </el-descriptions-item>

            </el-descriptions>

        </div>
        <tableTotal :index-show="configTable.indexShow" :config-data="configTable.configData" :table-data="showObject"
            :loading="configTable.loading" :height="configTable.height">

            <template #priceInfo="{ data }">
                <el-input type="number" v-if="orderRole != 'buyer'" v-model="data.goodsOrderItemPrice.goodsPrice"
                    placeholder="请输入成交价格"></el-input>
                <div v-else style="font-weight: 700;color:#1be1a6;font-size: 20px;">¥ {{ data.goodsOrderItemPrice.goodsPrice
                }}</div>
            </template>
            <template #goodsDescribe="{ data }">
                <div>{{ data.goodsOrderItemPrice.remark }}</div>
            </template>


        </tableTotal>
        <div v-if="orderRole == 'buyer'" style="margin: 15px auto;">
            <el-input type="textarea" v-model="OrderRemark" placeholder="请输入备注内容"></el-input>

        </div>


        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDig">取 消</el-button>
            <el-button type="info" v-if="orderRole == 'buyer'" @click="clueEvent()">拒绝交易内容</el-button>
            <el-button type="primary" @click="SubmitEvent()">确认交易信息</el-button>
        </span>

    </div>
</template>
  
<script>
import tableTotal from "@/components/TableTotal/TableTotal";

export default {
    name: "seeGoodsInfo",
    props: ['goodsInfo', 'orderRole'],
    data() {
        return {
            OrderRemark: '',
            showObject: [],
            orderStatusList: {
                0: '全部状态',
                1: '待付款',
                2: '待发货',
                3: '待收货',
                4: '待评价',
                5: '已完成',
                6: '已取消',
                7: '交易中',//线下
                8: '交易确认中',//线下
            },
            // 退款状态：0:默认,1:在处理,2:处理完成
            refundStatusList: {
                0: '默认',
                1: '在处理',
                2: '处理完成',
            },
            //支付方式 ： 1 ：微信支付 ；2： 支付宝；3：数字人民币；4：银联支付
            payList: {
                1: '微信支付',
                2: '支付宝',
                3: '数字人民币',
                4: '银联支付',
            },
            // 配置表格
            configTable: {
                height: 400,
                loading: false,
                indexShow: false,
                configData: [
                    {
                        value: 'goodsThumbnail',
                        label: '指姆图',
                        width: 150,
                        align: 'left',
                        type: 'img'
                    }, {
                        value: 'goodsName',
                        label: '产品名称',
                        align: 'left',
                        isCopy: true,
                    },
                    {
                        label: '支付类型',
                        value: 'goodsPriceType',
                        width: 120,
                        align: 'center',
                        objList: {
                            1: '-',
                            2: '价格面议',
                            3: '免费',
                            null: '-'
                        }
                    },
                    {
                        value: 'goodsPrice',
                        label: '商品原价格',
                        align: 'center',
                        type: 'price',
                        style: {
                            css: 'font-weight: 700;color:#e1251b;',
                            currency: '￥',
                        }
                    },
                    {
                        value: '',
                        label: '子订单备注',
                        align: 'left',
                        type: "custom",
                        customName: "goodsDescribe"

                    },
                    {
                        value: 'goodsCategory',
                        label: '商品类型',
                        align: 'center',
                        objList: {
                            1: '影像数据',
                            2: '数据产品',
                            3: '软件产品',
                            4: '其他产品'
                        }
                    },
                    {
                        value: '',
                        label: '成交价格',
                        align: 'center',
                        type: "custom",
                        customName: "priceInfo"
                    },

                    // {
                    //   value: 'goodsPriceType',
                    //   label: '商品价格类型',
                    //   align: 'left',
                    //   objList: { // 商品价格类型：1：商品金额：2：面议；3：免费
                    //     1: '商品金额',
                    //     2: '面议',
                    //     3: '免费',
                    //   }
                    // },
                ],
                tableData: [],
            },
        }
    },
    // 创建完成
    created() {
        // console.log(this.goodsInfo);
        this.showObject = this.goodsInfo;
    },
    // import引入的组件需要注入到对象中才能使用
    components: {
        tableTotal
    },
    // 方法集合
    methods: {
        async clueEvent() {
            var that = this;
            // that.$message.success('交易信息已退回卖家');
            // return false;
            let params = []
            this.showObject.forEach((item) => {
                
                item.goodsOrderItemPrice.remark = this.OrderRemark;
                item.goodsOrderItemPrice.status = 2;
                params.push(item.goodsOrderItemPrice)
            })
            // 买家审核  拒绝
            try {
                let res = await this.$http.post(this.$const.personalCenter.goodsOrderItemPriceBuyerConfirm, params);
                if (res && res.data) {
                    that.$message.success('交易信息已退回卖家');
                          
                }
            } catch (e) {
                console.log(e);
            }
            setTimeout(function () {
                        that.closeDig()
                    }, 2000)
          
           
        },
        async SubmitEvent() {
            var that = this;
            console.log(this.showObject);
            let params = []
            this.showObject.forEach((item) => {
                if (item.goodsOrderItemPrice.goodsPrice == null && this.orderRole == 'Seller') {
                    this.$message.warning('请先填写各商品价格');
                    params = [];
                    return false;

                }
                item.goodsOrderItemPrice.remark = this.OrderRemark;
                if (this.orderRole == 'buyer') {
                    item.goodsOrderItemPrice.status = 1;//买家同意
                }
                params.push(item.goodsOrderItemPrice)
            })
            if (this.orderRole == 'Seller' && this.showObject[0].goodsOrderItemPrice.orderItemPriceId == null) {
                // 新增卖家 价格修改
                try {
                    let res = await this.$http.post(this.$const.personalCenter.goodsOrderItemPriceSellerSetPrice, params);
                    if (res && res.data) {
                        that.$message.success('修改订单成功，等待买家确认');
                    }
                } catch (e) {
                    console.log(e);
                }
            } else if (this.orderRole == 'Seller' && this.showObject[0].goodsOrderItemPrice.orderItemPriceId != null) {
                // 编辑卖家 价格修改
                try {
                    let res = await this.$http.post(this.$const.personalCenter.goodsOrderItemPriceSellerResetPrice, params);
                    if (res && res.data) {
                        console.log(111111);
                        that.$message.success('修改订单成功，等待买家确认');
                    }
                } catch (e) {
                    console.log(e);
                }
            } else if (this.orderRole == 'buyer') {
                // 买家审核 通过
                try {
                    let res = await this.$http.post(this.$const.personalCenter.goodsOrderItemPriceBuyerConfirm, params);
                    if (res && res.data) {
                        that.$message.success('交易已完成');
                    }
                } catch (e) {
                    console.log(e);
                }
            }
            setTimeout(function () {
                that.closeDig()
            }, 2500)

        },
        closeDig() {
            this.$emit('cloeseDig')
        }
    }
}
</script>
  
<style lang="scss" scoped>
.info_box {
    max-height: 80vh;
    overflow-y: auto;
}

.imgInfo {
    width: 100px;
}

.dialog-footer {
    margin-top: 15px;
    float: right;
}
</style>
  